import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VDialog,{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.getGlobalConfirmDelete),callback:function ($$v) {_vm.getGlobalConfirmDelete=$$v},expression:"getGlobalConfirmDelete"}},[_c(VCard,[_c(VCardTitle,{staticClass:"text-h5 lighten-2",style:({
          'backdround-color': _vm.getThemeColor,
          color: _vm.getSecondaryColor,
        })},[_vm._v("Confirm Delete")]),_c(VCard,{staticClass:"mx-10",attrs:{"shaped":"","elevation":"12","outlined":""}},[_c(VContainer,[_c(VRow,[_c(VBtn,{staticClass:"mt-4 mb-10 mx-auto",style:({
                'background-color': 'red',
                color: 'white',
              }),attrs:{"rounded":""},on:{"click":function($event){return _vm.deleteConfirmed(true)}}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-times")]),_vm._v(" Delete "+_vm._s(_vm.item)+" ")],1)],1)],1)],1),_c(VDivider),_c(VCardActions,[_c(VSpacer),_c(VBtn,{style:(_vm.getThemeStyle),attrs:{"dark":""},on:{"click":function($event){return _vm.deleteConfirmed(false)}}},[_vm._v("Close")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }